"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
function onChange() {}
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.InputNumber, {
    min: 1,
    max: 10,
    defaultValue: 3,
    onChange: onChange
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimaryBorder', 'controlOutline', 'colorPrimaryHover', 'colorPrimary', 'colorBgContainer'],
  key: 'default'
};
var _default = exports.default = componentDemo;